var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSassBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 28,
    role: "img",
    "aria-label": "SASS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SASS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 28,
    fill: "#cc6699"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlNhc3M8L3RpdGxlPjxwYXRoIGQ9Ik0xMiAwYzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJzLTUuMzczIDEyLTEyIDEyUzAgMTguNjI3IDAgMTIgNS4zNzMgMCAxMiAwek05LjYxNSAxNS45OThjLjE3NS42NDUuMTU2IDEuMjQ4LS4wMjQgMS43OTJsLS4wNjUuMThjLS4wMjQuMDYxLS4wNTIuMTItLjA3OC4xNzYtLjE0LjI5LS4zMjYuNTYtLjU1NS44MS0uNjk4Ljc1OS0xLjY3MiAxLjA0Ny0yLjA5LjgwNS0uNDUtLjI2Mi0uMjI2LTEuMzM1LjU4NC0yLjE5Ljg3MS0uOTE4IDIuMTItMS41MDkgMi4xMi0xLjUwOXYtLjAwM2wuMTA4LS4wNjF6bTkuOTExLTEwLjg2MWMtLjU0Mi0yLjEzMy00LjA3Ny0yLjgzNC03LjQyMi0xLjY0NS0xLjk4OS43MDctNC4xNDQgMS44MTgtNS42OTMgMy4yNjdDNC41NjggOC40OCA0LjI3NSA5Ljk4IDQuMzk2IDEwLjYwN2MuNDI3IDIuMjExIDMuNDU3IDMuNjU3IDQuNzAzIDQuNzN2LjAwNmMtLjM2Ny4xOC0zLjA1NiAxLjUyOS0zLjY4NiAyLjkyNS0uNjc1IDEuNDcuMTA1IDIuNTIxLjYxNSAyLjY1NSAxLjU3NS40MzYgMy4xOTUtLjM2IDQuMDY1LTEuNjQ5Ljg0LTEuMjYxLjc2Ni0yLjg4MS40MDQtMy42NzYuNDk2LS4xMzUgMS4wOC0uMTk1IDEuODMtLjEwNCAyLjEwMS4yNCAyLjUyMSAxLjU2IDIuNDMgMi4xLS4wOS41MzktLjUyMy44NTQtLjY3NC45NDQtLjE1LjA5MS0uMTk1LjEyLS4xODEuMTgxLjAxNS4wOS4wOTEuMDkuMjEuMDc1LjE2NS0uMDMgMS4wOTYtLjQ1IDEuMTQxLTEuNDcxLjA0NS0xLjI5LTEuMTg2LTIuNzI5LTMuMzc1LTIuNy0uOS4wMTYtMS40NzEuMDkxLTEuODc1LjI1Ni0uMDMtLjA0NS0uMDYxLS4wNzUtLjEwNS0uMTA1LTEuMzUtMS40NTUtMy44NTUtMi40NzUtMy43NS00LjQxLjAzLS43MDUuMjg1LTIuNTY0IDQuOC00LjgxNCAzLjcwNS0xLjg0NiA2LjY2MS0xLjMzNSA3LjE3MS0uMjEuNzMzIDEuNjA0LTEuNTc2IDQuNTktNS40MzEgNS4wMjQtMS40Ny4xNjUtMi4yMzUtLjQwNC0yLjQzMS0uNjE1LS4yMDktLjIyNS0uMjM5LS4yNC0uMzE0LS4xOTQtLjEyLjA2LS4wNDUuMjU1IDAgLjM3NS4xMi4zLjU4NS44MjUgMS4zOTYgMS4wOTUuNzA0LjIyNSAyLjQzLjM1OSA0LjUtLjQ1IDIuMzI0LS44OTkgNC4xMzktMy40MDUgMy42MTQtNS41MDVsLjA3My4wNjd6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 490,
    y: 175,
    textLength: 340,
    fill: "#fff",
    fontWeight: "bold"
  }, "SASS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSassBadge);
export default __webpack_public_path__ + "static/media/sass_badge.fe828cd9133e1f9e756295d6f3824ec3.svg";
export { ForwardRef as ReactComponent };